import { gql } from '@apollo/client';

export const CRM_CONTRACT_TEMPLATE_FIELDS = `
    _id
    name
    body
    status
    createdAt
    updatedAt
`;

export const LIST_CRM_CONTRACT_TEMPLATES = gql`
    query ListCrmContractTemplates($input: ListCrmContractTemplatesInput!) {
        listCrmContractTemplates(input: $input) {
            data {
                ${CRM_CONTRACT_TEMPLATE_FIELDS}
            }
            pagination {
                total
                hasNextPage
            }
        }
    }
`;

export const GET_CRM_CONTRACT_TEMPLATE_DETAILS = gql`
    query GetCrmContractTemplateDetails($id: String!) {
        getCrmContractTemplateDetails(id: $id) {
            ${CRM_CONTRACT_TEMPLATE_FIELDS}
        }
    }
`;
